<template>
    <div>
        <el-table
            :data="listData"
            border
            highlight-current-row
            :row-class-name="highlightResult"
            :header-cell-style="{background:'#989ea5',color:'#000'}">

            <!-- <el-table-column
                type="selection"
                width="50">
            </el-table-column> -->
            <el-table-column align="center" label="RelayID" prop="relayId"></el-table-column>
            <el-table-column align="center" label="RelayName" prop="relayName" width="120px"></el-table-column>
            <el-table-column align="center" label="探测带宽(Kbit/S)" prop="bw">
            </el-table-column>
            <el-table-column align="center" prop="pkSize" width="100px">
                <template slot="header">
                    <div>探测包大小</div>
                    <div>(KByte)</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="探测方向" prop="direction"></el-table-column>
            <el-table-column align="center" prop="loss" width="74px">
                <template slot="header">
                    <div>丢包率</div>
                    <div>(%)</div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="delay">
                <template slot="header">
                    <div>时延</div>
                    <div>(ms)</div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="jitter" width="74px">
                <template slot="header">
                    <div>抖动</div>
                    <div>(ms)</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="网络状况" prop="">
                <!-- <template slot-scope="scope">
                    <span :class="scope.row.isBadNetwork == 1 ? 'dangerInfo' : ''">{{scope.row.isBadNetwork == 0 ? '合格' : '不合格' }}</span>
                </template> -->
            </el-table-column>
            <el-table-column align="center" label="探测状态" prop="result">
                <template slot-scope="scope">
                    <!-- <span :class="scope.row.result == 1 ? 'dangerInfo' : ''">
                        {{scope.row.result}}
                    </span> -->
                    <span :class="scope.row.result == 1 ? 'dangerInfo' : ''">
                        {{scope.row.result == 0 ? '成功' : '失败' }}
                    </span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="探测时间" prop="detectTm">
                <template slot-scope="scope">
                    {{scope.row.detectTm ? new Date(scope.row.detectTm).Format('yyyy-MM-dd hh:mm:ss') : ''}}
                </template>
            </el-table-column>

            <el-table-column align="center" prop="duration">
                <template slot="header">
                    <div>探测时长</div>
                    <div>(S)</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="RelayIP" prop="relayIp"></el-table-column>
        </el-table>
    </div>
</template>
<script>
import { Loading } from "element-ui";
export default {
    name:'EventDetail',
    props: {
        rowId: {
            type: [String, Number]
        }
    },
    data: vm=>({
        listData: []
    }),
    created(){
        this.getDetail()
    },
    methods: {
        highlightResult({row, rowIndex}) {
          if (row.type == '1') {
            return 'warning-row';
          }
          return '';
        },
        getDetail(){
            if(!this.rowId){
                return
            }
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios
                .get(
                this.detectApiUrl +
                    "unpackDetect/findAllOfDetail/" + this.rowId
                )
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        data.forEach(obj => {
                            obj.jitter = '-'
                        })
                        this.listData = data;
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        }
    }
}
</script>
<style scoped>
  .dangerInfo{
    color: red;
  }
  .el-table /deep/ .warning-row {
    background: #caf9bb;
  }
</style>
